import React from "react";

import background from "../storage/background-blur.png";

const Layout = (props) => {
	return (
		<div className="font-nunito bg-black min-h-screen h-auto w-full bg-no-repeat bg-cover" style={{ backgroundImage: `url('${background}')` }}>
			<div className={`min-h-screen h-auto bg-black bg-opacity-30 ${props.topImage ? "flex flex-col" : "flex justify-center align-middle pt-12 pb-8 px-4 md:pt-0 md:pb-0 md:px-0"}`}>
				{props.topImage && (
					<div className="flex flex-col items-center pt-6 pb-2">
						<img src={props.topImage} alt="" className="h-40 object-contain drop-shadow-xl" />
						{props.topContent && (
							<div className="mt-2 text-center text-white">{props.topContent}</div>
						)}
					</div>
				)}
				{props.topImage ? (
					<div className="flex justify-center items-center flex-1 pb-8 px-4 md:px-0">
						{props.children}
					</div>
				) : props.children}
			</div>
		</div>
	);
};

export default Layout;
